import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../../service/auth.service";
import {NotificationsService} from "../../../service/notifications.service";
import {ContactUsService} from "../../../service/contact-us.service";
import {ContactUsForm} from "../../../model/ContactUsForm";
import {tap} from "rxjs";
import {User} from "../../../model/User";
import {ActivatedRoute} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {DirectAccessService} from "../../../service/direct-access.service";

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['../../../../styles.scss', './contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  form: FormGroup;
  loading = false;
  isAnonymous = true;
  key: string

  constructor(private http: HttpClient,
              private fb: FormBuilder,
              private authService: AuthService,
              private contactUsService: ContactUsService,
              private notificationService: NotificationsService,
              private dialogRef: MatDialogRef<ContactUsComponent>,
              private activatedRoute: ActivatedRoute,
              private directAccessService: DirectAccessService) {
    this.form = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      username: ['',],
      email: ['', [Validators.required, Validators.email]]
    });

    this.activatedRoute.queryParams.pipe(
      tap(params => {
        this.key = params['key'];
      })).subscribe();

    if (this.authService.isAuthenticated.getValue() === true || this.key !== undefined) {
      this.isAnonymous = false;
    }
  }

  ngOnInit(): void {
    if (this.key !== undefined) {
      this.directAccessService.getDaUser(this.key).subscribe({
        next: user => {
          this.fillForm(user)
        }
      });
    } else {
      this.authService.currentUser$.subscribe(user => {
        if (user) {
          this.fillForm(user)
        }
      })
    }
  }

  sendFeedback(): void {
    if (this.form.valid) {
      const contactUsForm = new ContactUsForm(this.form.controls.title.value, this.form.controls.description.value, this.form.controls.email.value);
      this.loading = true;
      this.contactUsService.submitContactUsForm(contactUsForm).subscribe({
        next: res => {
          this.loading = false;
          this.notificationService.messageNotifySuccess("Thanks for your feedback!")
          this.dialogRef.close();
        }, error: error => {
          this.loading = false;
          this.dialogRef.close();
        }
      })
    } else {
      console.error('Form invalid!');
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  private fillForm(user: User): void {
    this.form.controls.email.setValue(user.email);
    this.form.controls.email.disable({onlySelf: true});
    this.form.controls.username.setValue(user.firstName + ' ' + user.lastName);
    this.form.controls.username.disable({onlySelf: true});
  }

}
